import React, { useMemo, useState } from 'react';
import { authService } from '../../services';
import ChangePasswordModal from '../../components/modals/ChangePasswordModal';
import ChangeTPinModal from '../../components/modals/ChangeTPinModal';

const MyProfile = () => {
  const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
  const [showChangeTPinModal, setShowChangeTPinModal] = useState(false);
  const [isEditingParentMobile, setIsEditingParentMobile] = useState(false);
  const [parentMobileDraft, setParentMobileDraft] = useState('');

  const storedProfile = useMemo(() => {
    if (typeof window === 'undefined') {
      return {};
    }

    return {
      role: authService.getUserRole() || 'user',
      mobile: localStorage.getItem('mobile') || '',
      email: localStorage.getItem('email') || '',
      fullName: localStorage.getItem('fullName') || localStorage.getItem('name') || '',
      address: localStorage.getItem('address') || '',
      occupation: localStorage.getItem('occupation') || '',
      superDistributorName: localStorage.getItem('superDistributorName') || localStorage.getItem('superDistributor') || '',
      superDistributorMobile: localStorage.getItem('superDistributorMobile') || '',
      masterDistributorName: localStorage.getItem('masterDistributorName') || localStorage.getItem('masterDistributor') || '',
      masterDistributorMobile: localStorage.getItem('masterDistributorMobile') || '',
      distributorName: localStorage.getItem('distributorName') || '',
      distributorMobile: localStorage.getItem('distributorMobile') || '',
    };
  }, []);

  const profileData = {
    fullName: storedProfile.fullName || 'User User',
    role: storedProfile.role ? storedProfile.role.replace(/_/g, ' ') : 'User',
    email: storedProfile.email || 'User@info.com',
    mobile: storedProfile.mobile || '3333333333',
    address: storedProfile.address || 'User Address, City',
    occupation: storedProfile.occupation || 'User Profession',
  };

  const roleKey = storedProfile.role || '';
  const parentDetailFields = [];

  if (roleKey === 'master_distributor') {
    parentDetailFields.push({
      label: 'Super Distributor',
      name: storedProfile.superDistributorName || 'Super Distributor Name',
      mobile: storedProfile.superDistributorMobile || profileData.mobile
    });
  }

  if (roleKey === 'distributor') {
    parentDetailFields.push({
      label: 'Master Distributor',
      name: storedProfile.masterDistributorName || 'Master Distributor Name',
      mobile: storedProfile.masterDistributorMobile || profileData.mobile
    });
  }

  if (roleKey === 'retailer') {
    parentDetailFields.push({
      label: 'Distributor',
      name: storedProfile.distributorName || 'Distributor Name',
      mobile: storedProfile.distributorMobile || profileData.mobile
    });
  }

  const handleEditProfile = () => {
    // Placeholder for future edit functionality
    alert('Edit profile functionality coming soon!');
  };

  const handleParentMobileEdit = (initialValue) => {
    setParentMobileDraft(initialValue || '');
    setIsEditingParentMobile(true);
  };

  const handleParentMobileSave = () => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('distributorMobile', parentMobileDraft);
      localStorage.setItem('superDistributorMobile', parentMobileDraft);
      localStorage.setItem('masterDistributorMobile', parentMobileDraft);
    }
    setIsEditingParentMobile(false);
  };

  const handleParentMobileCancel = () => {
    setIsEditingParentMobile(false);
  };

  return (
    <div className="profile-page container-fluid py-4">
      <div className="row g-4">
        <div className="col-12 col-xl-4">
          <div className="profile-summary-card">
            <div className="profile-avatar-wrapper">
              <div className="profile-avatar-circle">
                <i className="bi bi-person-fill"></i>
              </div>
              <button className="avatar-upload-btn" type="button">
                <i className="bi bi-camera-fill"></i>
              </button>
            </div>
            <h2 className="profile-name">{profileData.fullName}</h2>
            <p className="profile-email">{profileData.email}</p>
            <span className="profile-role-badge">{profileData.role}</span>
            <div className="profile-actions">
              <button className="btn btn-outline-primary w-100" onClick={handleEditProfile}>
                <i className="bi bi-pencil-square me-2"></i>
                Edit Profile
              </button>
              <button
                className="btn btn-outline-secondary w-100"
                onClick={() => setShowChangePasswordModal(true)}
              >
                <i className="bi bi-shield-lock-fill me-2"></i>
                Change Password
              </button>
              <button
                className="btn btn-outline-secondary w-100"
                onClick={() => setShowChangeTPinModal(true)}
              >
                <i className="bi bi-key-fill me-2"></i>
                Change T-PIN
              </button>
            </div>
          </div>
        </div>

        <div className="col-12 col-xl-8">
          <div className="profile-details-card">
            <div className="card-section">
              <h5 className="section-title">Personal Information</h5>
              <div className="row g-3">
                <div className="col-12 col-md-6">
                  <label className="form-label required">Full Name</label>
                  <input type="text" className="form-control" value={profileData.fullName} readOnly />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label required">Email Address</label>
                  <input type="email" className="form-control" value={profileData.email} readOnly />
                </div>
                <div className="col-12 col-md-6">
                  <label className="form-label required">Mobile Number</label>
                  <input type="text" className="form-control" value={profileData.mobile} readOnly />
                  {/* <small className="text-muted">Primary contact number</small> */}
                </div>
                <div className="col-12">
                  <label className="form-label">Address</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    value={profileData.address}
                    readOnly
                  ></textarea>
                  <small className="text-muted">
                    Include street, locality, city, state, and PIN code
                  </small>
                </div>
              </div>
            </div>

            {roleKey !== 'api_partner' && (
              <div className="card-section">
                <h5 className="section-title">Parent Details</h5>
                {parentDetailFields.length > 0 ? (
                  <div className="row g-3">
                    {parentDetailFields.map(({ label, name, mobile }) => (
                      <React.Fragment key={label}>
                        <div className="col-12 col-md-6">
                          <label className="form-label">{`${label} Name`}</label>
                          <input type="text" className="form-control" value={name} readOnly />
                        </div>
                        <div className="col-12 col-md-6">
                          <label className="form-label">{`${label} Number`}</label>
                          <div className="d-flex gap-2">
                            <input
                              type="text"
                              className="form-control"
                              value={isEditingParentMobile ? parentMobileDraft : mobile}
                              onChange={(e) => setParentMobileDraft(e.target.value)}
                              readOnly={!isEditingParentMobile}
                            />
                            {!isEditingParentMobile ? (
                              <button
                                type="button"
                                className="btn btn-outline-primary"
                                onClick={() => handleParentMobileEdit(mobile)}
                              >
                                Change
                              </button>
                            ) : (
                              <>
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  onClick={handleParentMobileSave}
                                >
                                  Save
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-outline-secondary"
                                  onClick={handleParentMobileCancel}
                                >
                                  Cancel
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                      </React.Fragment>
                    ))}
                  </div>
                ) : (
                  <div className="row g-3">
                    <div className="col-12 col-md-6">
                      <label className="form-label">Name</label>
                      <input type="text" className="form-control" value={profileData.fullName} readOnly />
                    </div>
                    <div className="col-12 col-md-6">
                      <label className="form-label">Number</label>
                      <div className="d-flex gap-2">
                        <input
                          type="text"
                          className="form-control"
                          value={isEditingParentMobile ? parentMobileDraft : profileData.mobile}
                          onChange={(e) => setParentMobileDraft(e.target.value)}
                          readOnly={!isEditingParentMobile}
                        />
                        {!isEditingParentMobile ? (
                          <button
                            type="button"
                            className="btn btn-outline-primary"
                            onClick={() => handleParentMobileEdit(profileData.mobile)}
                          >
                            Edit
                          </button>
                        ) : (
                          <>
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={handleParentMobileSave}
                            >
                              Save
                            </button>
                            <button
                              type="button"
                              className="btn btn-outline-secondary"
                              onClick={handleParentMobileCancel}
                            >
                              Cancel
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>

      <ChangePasswordModal
        show={showChangePasswordModal}
        handleClose={() => setShowChangePasswordModal(false)}
      />

      <ChangeTPinModal
        show={showChangeTPinModal}
        handleClose={() => setShowChangeTPinModal(false)}
      />
    </div>
  );
};

export default MyProfile;

